import { useAuth } from "@/auth/AuthProvider";
import { Roles } from '@/types/auth/auth';

export const useRole = () => {
  const { userProfile } = useAuth();

  const hasRole = (allowedRoles: string | string[]) => {
    if (!userProfile?.role) return false;

    const roles = Array.isArray(allowedRoles) ? allowedRoles : [allowedRoles];
    return roles.includes(userProfile.role);
  };

  const isInternalAdmin = () => hasRole(Roles.Admin);
  const isBusinessUser = () => hasRole([Roles.Business]);
  const isConsumer = () => hasRole(Roles.Consumer);

  return {
    userRole: userProfile?.role,
    hasRole,
    isInternalAdmin,
    isBusinessUser,
    isConsumer,
  };
};
